import { css } from 'lit';

/*
  Shared visual style for radio and checkbox controls. Mirrors the React
  `.catalog-filter__option-label-checkbox` pattern so radios/checkboxes look
  identical across React and Lit.

  Two supported markup patterns — pick whichever fits the surrounding layout:

  1) Wrapping label (preferred — implicit input/label association):

     <label class="tf-choice">
       <span class="tf-choice__control tf-choice__control--radio">
         <input type="radio" name="..." value="..." />
         <span class="tf-choice__control-fill"></span>
       </span>
       <span class="tf-choice__text">Visible text</span>
     </label>

  2) Sibling label with for/id (for grid layouts where wrapping isn't viable):

     <span class="tf-choice__control tf-choice__control--radio">
       <input type="radio" id="x" name="..." />
       <span class="tf-choice__control-fill"></span>
     </span>
     <label for="x" class="tf-choice__text">Visible text</label>

  Drop --radio for checkbox (square instead of circle).
*/

export const choiceStyles = css`
  .tf-choice {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    user-select: none;
    margin-bottom: 8px;
  }

  .tf-choice__control {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: 12px;
    padding: 0;
    border: 1px solid #222222;
    box-sizing: border-box;
  }

  .tf-choice__control--radio {
    border-radius: 50%;
  }

  .tf-choice__control input[type='radio'],
  .tf-choice__control input[type='checkbox'] {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    margin: 0;
    cursor: pointer;
  }

  .tf-choice__control-fill {
    display: block;
    width: 70%;
    height: 70%;
    background-color: transparent;
  }

  .tf-choice__control--radio .tf-choice__control-fill {
    border-radius: 50%;
  }

  .tf-choice:hover input:not(:checked) ~ .tf-choice__control-fill,
  .tf-choice__control:hover input:not(:checked) ~ .tf-choice__control-fill {
    background-color: #dddddd;
  }

  .tf-choice__control input:checked ~ .tf-choice__control-fill {
    background-color: #ff993d;
  }

  /* Keyboard focus only: a click also focuses the input, and the ring
     would otherwise stay lit after every click. Same ring as the other
     controls. */
  .tf-choice__control:has(input:focus-visible) {
    outline: 2px solid #222222;
    outline-offset: 2px;
  }

  .tf-choice__text {
    font-size: 1rem;
    line-height: 1.25;
    letter-spacing: -0.2px;
    cursor: pointer;
  }
`;
